const SLASH = 47;

// Linear-time stand-ins for `/^\/+/` and `/\/+$/`, which Sonar (S8786) flags as super-linear.
export const trimLeadingSlashes = (value: string): string => {
  let start = 0;

  while (start < value.length && value.charCodeAt(start) === SLASH) start += 1;

  return value.slice(start);
};

export const trimTrailingSlashes = (value: string): string => {
  let end = value.length;

  while (end > 0 && value.charCodeAt(end - 1) === SLASH) end -= 1;

  return value.slice(0, end);
};

export const trimSlashes = (value: string): string => trimTrailingSlashes(trimLeadingSlashes(value));
